var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateFiller(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 46.8125H19.25M14.6667 50.25H18.3333",
    stroke: "#0F172A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1896 38.8106L11.7076 40.2395C12.1335 40.6404 12.375 41.1993 12.375 41.7841C12.375 42.6627 13.0873 43.375 13.9659 43.375H19.0341C19.9127 43.375 20.625 42.6627 20.625 41.7841C20.625 41.1993 20.8665 40.6404 21.2924 40.2395L22.8104 38.8106C24.9296 36.8007 26.113 34.1603 26.1249 31.4152L26.125 31.2998C26.125 26.6095 21.8157 22.75 16.5 22.75C11.1843 22.75 6.875 26.6095 6.875 31.2998L6.87509 31.4152C6.88703 34.1603 8.07042 36.8007 10.1896 38.8106Z",
    stroke: "#0F172A",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2477 3.72991C31.763 2.42336 33.612 2.42336 34.1273 3.72992L35.7242 7.77881C35.8815 8.17771 36.1973 8.49347 36.5962 8.65079L40.6451 10.2477C41.9516 10.763 41.9516 12.612 40.6451 13.1273L36.5962 14.7242C36.1973 14.8815 35.8815 15.1973 35.7242 15.5962L34.1273 19.6451C33.612 20.9516 31.763 20.9516 31.2477 19.6451L29.6508 15.5962C29.4935 15.1973 29.1777 14.8815 28.7788 14.7242L24.7299 13.1273C23.4234 12.612 23.4234 10.763 24.7299 10.2477L28.7788 8.65079C29.1777 8.49347 29.4935 8.17771 29.6508 7.77881L31.2477 3.72991Z",
    fill: "#F6A723",
    stroke: "#F6A723",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2712 18.4135C44.5544 17.6955 45.5706 17.6955 45.8538 18.4135L47.0922 21.5536C47.1787 21.7728 47.3522 21.9463 47.5714 22.0328L50.7115 23.2712C51.4295 23.5544 51.4295 24.5706 50.7115 24.8538L47.5714 26.0922C47.3522 26.1787 47.1787 26.3522 47.0922 26.5714L45.8538 29.7115C45.5706 30.4295 44.5544 30.4295 44.2712 29.7115L43.0328 26.5714C42.9463 26.3522 42.7728 26.1787 42.5536 26.0922L39.4135 24.8538C38.6955 24.5706 38.6955 23.5544 39.4135 23.2712L42.5536 22.0328C42.7728 21.9463 42.9463 21.7728 43.0328 21.5536L44.2712 18.4135Z",
    fill: "#F6A723",
    stroke: "#F6A723",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateFiller);
export default __webpack_public_path__ + "static/media/generate_filler.56cf06ed6cc782903935d0c85a9dcd5a.svg";
export { ForwardRef as ReactComponent };